var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentAttachmentPod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0806 8.75033V8.33366C17.0806 5.19096 17.0806 3.61962 16.1044 2.6433C15.1281 1.66699 13.5567 1.66699 10.414 1.66699H9.58073C6.43809 1.66699 4.86675 1.66699 3.89045 2.64329C2.91414 3.61959 2.91412 5.19093 2.9141 8.3336L2.91406 12.0837C2.91404 14.8232 2.91403 16.193 3.67063 17.1149C3.80916 17.2837 3.96395 17.4385 4.13275 17.5771C5.0547 18.3337 6.42447 18.3337 9.16398 18.3337",
    stroke: "#2C3A4B",
    strokeOpacity: 0.9,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 5.83313H13.75",
    stroke: "#2C3A4B",
    strokeOpacity: 0.9,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10H11.25",
    stroke: "#2C3A4B",
    strokeOpacity: 0.9,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3317 11.6685V12.6678C17.3317 13.9557 16.2877 14.9997 14.9998 14.9997M14.9998 14.9997C13.712 14.9997 12.668 13.9557 12.668 12.6678V11.6685M14.9998 14.9997C16.2877 14.9997 17.3317 16.0437 17.3317 17.3316V18.331M14.9998 14.9997C13.712 14.9997 12.668 16.0437 12.668 17.3316V18.331",
    stroke: "#2C3A4B",
    strokeOpacity: 0.9,
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3359 11.6685H17.6659M17.6659 18.331H12.3359",
    stroke: "#2C3A4B",
    strokeOpacity: 0.9,
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAttachmentPod);
export default __webpack_public_path__ + "static/media/document-attachment-pod.7eeb73c1a8ca25fea7b4d249cdc0f1b1.svg";
export { ForwardRef as ReactComponent };